/* eslint-disable */
import { binarySearch } from '../util/index'
import { Horizontal } from '../component/scroll/index'
export default {
  name: 'virtual',
  components: { Horizontal },
  props: {
    height: { // 滚动高度
      type: Number
      // default: 390
    },
    width: {
      type: Number, // 宽度
      default: () => 0
    },
    dHeight: {
      type: Number, // 高度差值
      default: () => 0
    },
    dataSource: {
      type: Array, // 列表数据，垂直
      default: () => ([])
    },
    estimatedRowHeight: {
      type: Number, // 预估高度
      default: () => 150
    },
    bufferSize: {
      type: Number, // 防止白屏 buffe
      default: () => 3
    },
    groupScroll: {
      type: Boolean, // 组内滚动
      default: () => false
    },
    parentClass: {
      type: String, // list wrap 
      default: null
    },
    groupIndex: {
      type: Number, // 防止白屏 buffe
      default: () => null
    },
    tableStartIndex: {
      type: Number, // 防止白屏 buffe
      default: () => null
    },
    isVirtual: {
      type: Boolean, // 是否开启虚拟滚动
      default: () => true
    }
  },
  data() {
    // 纵向滚动
    this.init()
    return {
      startIndex: 0,
      endIndex: Math.min(
        this.originStartIdx + this.limit + this.bufferSize,
        this.total
      ),
      phantomHeight: this.estimatedRowHeight * this.total,
      scrollTop: 0,
      scrollLeft: 0,
    }
  },
  created() {
    this.initCachedPositions()
    this.$emit('updateData', this.startIndex, this.endIndex, this.scrollTop, this.phantomHeight, this.getTransform())
  },
  watch: {
    dataSource: {
      handler (newVal) {
        if (newVal) {
          this.total = newVal?.length // 总数
          this.init()
          this.initCachedPositions()
          this.$emit('updateData', this.startIndex, this.endIndex, this.scrollTop, this.phantomHeight, this.getTransform())
        }
      }
    }
  },
  computed: {

  },
  updated() {
    this.updateCachedPositions();
    if(this.verticalList){
      this.verticalList.scrollTop = this.scrollTop
    }
  },
  methods: {
    // 初始化处理
    init () {
      this.boxHeight = this.height ? Number(this.height - this.dHeight) : '100%'
      this.originStartIdx = 0 //开始下
      this.total = this.dataSource?.length // 总数
      this.cachedPositions = [] // 缓存高
      this.limit = Math.ceil(this.boxHeight / this.estimatedRowHeight)
      this.startIndex = 0
      this.endIndex =  Math.min(
        this.originStartIdx + this.limit + this.bufferSize,
        this.total
      )
      this.phantomHeight = this.estimatedRowHeight * this.total
      this.scrollTop =  0
      this.scrollLeft = 0
    },
    // 初始化高度，无tableHeard 高度
    initCachedPositions() {
      const { estimatedRowHeight } = this;
      this.cachedPositions = [];
      for (let i = 0; i < this.total; ++i) {
        this.cachedPositions[i] = {
          index: i,
          height: estimatedRowHeight,
          top: i * estimatedRowHeight,
          bottom: (i + 1) * estimatedRowHeight,
          dValue: 0
        }
      }
    },
    // 初始化高度
    // 更新缓存 位置
    updateCachedPositions() {
      const nodes = !this.parentClass ? this.$el.childNodes[1].childNodes : document.querySelector(`.${this.parentClass}`)?.childNodes || []
      const start = nodes.length > 0 ? nodes[0] : null
      nodes.forEach((node) => {
        if (!node) {
          return;
        }
        // console.log('.childNodes', node.dataset);
        const rect = node.getBoundingClientRect();
        const { height } = rect;
        // const group = node.dataset.group.split("-")[1]
        const index = Number(node.id.split("-")[1]);
        if (isNaN(index)) {
          return
        }
        const oldHeight = this.cachedPositions[index].height;
        // // console.log('rect-height', height);
        // console.log('oldHeight', oldHeight);
        const dValue = oldHeight - height;
        if (dValue) {
          this.cachedPositions[index].bottom -= dValue;
          this.cachedPositions[index].height = height;
          this.cachedPositions[index].dValue = dValue;
        }
      });
      let startIdx = 0;
      if (start) {
        startIdx = Number(start.id.split("-")[1]);
      }
      if (isNaN(startIdx)) {
        return
      }
      const cachedPositionsLen = this.cachedPositions.length
      if (!cachedPositionsLen) {
        return
      }
      let cumulativeDiffHeight = this.cachedPositions[startIdx].dValue;
      this.cachedPositions[startIdx].dValue = 0;

      for (let i = startIdx + 1; i < cachedPositionsLen; ++i) {
        const item = this.cachedPositions[i];
        this.cachedPositions[i].top = this.cachedPositions[i - 1].bottom;
        this.cachedPositions[i].bottom =
          this.cachedPositions[i].bottom - cumulativeDiffHeight;
        if (item.dValue !== 0) {
          cumulativeDiffHeight += item.dValue;
          item.dValue = 0;
        }
      }
      const height = this.cachedPositions[cachedPositionsLen - 1].bottom;
      this.phantomHeight = height;
    },
    // 纵向滚动距离
    getTransform() {
      return `translate3d(0,${this.startIndex >= 1
          ? this.cachedPositions[this.startIndex - 1].bottom
          : 0
        }px,0)`
    },
    // 获取index
    getStartIndex(scrollTop = 0) {
      let idx = binarySearch(this.cachedPositions, scrollTop, (currentValue, targetValue) => {
        const currentCompareValue = currentValue.bottom;
        if (currentCompareValue === targetValue) {
          return 1;
        }

        if (currentCompareValue < targetValue) {
          return 2;
        }

        return 3;
      }
      )
      const targetItem = this.cachedPositions[idx];
      if (targetItem.bottom < scrollTop) {
        idx += 1;
      }
      return idx;
    },
    // 垂直滚动
    handleVerticalScroll(event) {
      // console.log(`this.scrollTop:${this.groupIndex}`, this.scrollTop)
      const scrollTop = event.target.scrollTop
      const scrollLeft = event.target.scrollLeft
      if (this.scrollTop === scrollTop) {
        console.log('横向', scrollLeft);
        return
      }
      const { originStartIdx, bufferSize, total } = this;
      const currentStartIndex = this.getStartIndex(scrollTop);
      if (currentStartIndex !== originStartIdx) {

        this.originStartIdx = currentStartIndex;
        this.startIndex = Math.max(this.originStartIdx - bufferSize, 0);
        this.endIndex = Math.min(
          this.originStartIdx + this.limit + bufferSize,
          total
        )
      }
      this.scrollTop = scrollTop
      this.$emit('updateData', this.startIndex, this.endIndex, this.scrollTop, this.phantomHeight, this.getTransform())
    },
    handleHorizontalScroll(event) {
      console.log('event', event);

    },
    // 纵向滚动距离
    getTransform() {
      return `translate3d(0,${this.startIndex >= 1
          ? this.cachedPositions[this.startIndex - 1].bottom
          : 0
        }px,0)`
    },
    renderHorizontal(content) {
      return (
        <Horizontal
          onHorizontalScroll={this.handleHorizontalScroll}>
          {content}
        </Horizontal>
      )
    },
    _customUpdate () {
      return this
    }
  },
  destroyed() {
  },
  mounted() {
    if (!this.parentClass) {
      this.updateCachedPositions();
    }
    this.verticalList = this.$refs['vertical-list']
  },
  render() {
    const { phantomHeight, isVirtual } = this
    return <div
      style={{
        overflowY: this.isVirtual ? 'auto' : 'hidden',
        overflowX: 'hidden',
        'max-height': this.isVirtual ? (this.height - this.dHeight) + 'px' : 'auto',
        position: 'relative'
      }}
      ref='vertical-list'
      onScroll={this.handleVerticalScroll}
    >                  
      { isVirtual && <div
        class='phantomContentRef'
        style={{ height: (phantomHeight + this.dHeight) + 'px', position: "relative" }}
      /> }

      <div
        style={{
          width: "100%",
          position: isVirtual ? 'absolute' : '',
          top: 0,
          transform: this.getTransform()
        }}
      >
        {this.$scopedSlots.default}
      </div>
    </div>
  }
}
